export default __webpack_public_path__ + "static/media/no-data.2e8f0df9.svg";